import i18next from 'i18next';
import {
  IContractTemplateTreeItemForm,
  TEMPLATE_TYPE,
} from 'services/templates/types';

export const paragraphSectionTemplateInitialValues = (
  children?: IContractTemplateTreeItemForm[]
): IContractTemplateTreeItemForm[] => [
  {
    id: '0',
    type: TEMPLATE_TYPE.contract,
    content: i18next.t('contract-template.paragraphSection.contract-title'),
    disabled: true,
    disabledMoreButton: true,
    disabledCollapse: true,
    disabledSelection: true,
    disabledRemove: true,
    disabledInput: true,
    children: children ?? [
      {
        id: '1',
        type: TEMPLATE_TYPE.paragraphSection,
        content: '',
        children: [],
        disabledSelection: true,
        disabledRemove: true,
        autoFocus: true,
      },
    ],
  },
];
